import React from 'react';

const ModalContext = React.createContext({
  onClose: (evt) => {
    return evt;
  },
});

export default ModalContext;
